export const AccessRoles = () => {
  return ["Supervisor", "Editor", "Reader"];
};
